import styled from 'styled-components'
import Color from 'color'

export const EventGridWrapper = styled.div`
  display: flex;
`

export const DayColumn = styled.div`
  flex: 1 0 100px;
  &:not(:last-child) {
    border-right: 1px dashed #e6e8eb;
  }
  min-width: 0;
  overflow: hidden;
`

export const GridRow = styled.div<{ canAdd: boolean }>`
  height: 56px;
  border-bottom: 1px dashed #e6e8eb;
  padding: 0 7px;
  position: relative;
  cursor: ${props => (props.canAdd ? 'pointer' : 'initial')};

  &.is-weekend {
    background: repeating-linear-gradient(
      -60deg,
      #fff,
      #fff 8px,
      #f3f3f5 8px,
      #f3f3f5 9px
    );
  }
`

export const Event = styled.div<{ color: string }>`
  background-color: ${props => Color(props.color).lightness(99).string()};
  border: 1px solid ${props => props.color};
  color: ${props => props.color};
  border-left-width: 3px;
  border-radius: 4px;
  position: absolute;
  left: 7px;
  right: 7px;
  z-index: 1;
  overflow: hidden;
  cursor: pointer;
  font-size: 14px;
  transition: min-height 0.1s ease;
  min-height: 0px;

  &:hover {
    background-color: ${props => Color(props.color).lightness(98).string()};
    overflow: auto;
    z-index: 2;
    min-height: 100px;
  }

  &.unapproved {
    border-style: dashed;
    border-left-style: solid;
  }

  &.open-top {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    border-top: 0;
  }

  &.open-bottom {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    border-bottom: 0;
  }

  img {
    width: 20px;
    height: 20px;
    position: absolute;
    top: 10px;
    right: 12px;
    border-radius: 50%;
  }

  > div {
    margin-bottom: 4px;
    padding: 10px 12px;
  }

  > div:first-of-type {
    font-weight: 500;
    margin-right: 25px;
    margin-bottom: 6px;
  }
`
